module.exports = __webpack_public_path__ + "img/tags.5366dd35.jpg";